// Composables
import { createRouter, createWebHistory } from 'vue-router'

export default (app) => {
    const setupRoutes = $keycloak => {
        const { login, logout } = $keycloak.value

        async function authProtect(to, _from, next) {
            const { isLoaded, login } = $keycloak.value

            await isLoaded

            if ($keycloak.value.isAuthenticated) {
                next()
            } else {
                await login({
                    redirectUri: `${window.location.origin}${to.fullPath}`
                })
                next(false)
            }
        }
        return [
            {
                path: '/bicon/:hash',
                name: 'bicon',
                component: () => import('@/components/Bicon.vue'),
                alias: ['/avatar/:hash']
            }, {
                path: '/nut',
                name: 'home',
                component: () => import('@/views/SplashHome.vue'),
            }, {
                path: '/wap',
                name: 'wap',
                component: () => import('@/views/WebApp.vue'),
                children: [{
                    path: '',
                    name: 'root',
                    component: () => import('@/views/DoomScroller.vue'),
                }, {
                    path: 'account',
                    name: 'banc',
                    component: () => import('@/views/AccountHome.vue'),
                    beforeEnter: authProtect
                }, {
                    path: 'upload',
                    name: 'upload',
                    component: () => import('@/views/UploadTool.vue'),
                    beforeEnter: authProtect
                }]
            }, {
                path: '/@:userId/:timestamp',
                name: 'Shared Fuel',
                component: () => import('@/views/SharedFuel.vue'),
            }, {
                path: '/@:username',
                name: 'user-home',
                component: () => import('@/views/UserHome.vue'),
            }, {
                path: '/wtf',
                name: 'Frequently Asked Questions',
                component: () => import('@/components/FAQ.vue'),
            }, {
                path: '/signin',
                name: 'Web App Sign In',
                component: () => import('@/views/AccountHome.vue'),
                beforeEnter: (to) => {
                    login({ redirectUri: to.query.redirectUri || `${window.location.origin}/account` })
                },
                alias: ['/login']
            }, {
                path: '/signout',
                name: 'Web App Sign Out',
                component: () => import('@/views/SplashHome.vue'),
                beforeEnter: () => {
                    logout({ redirectUri: document.location.origin })
                },
                alias: ['/logout']
            }, {
                path: '/silent-check-sso',
                name: 'SSO Check',
                component: () => import('@/components/AuthCheckSso.vue')
            }, {
                path: '/:catchAll(.*)',
                name: 'catchall',
                beforeEnter: (to, from, next) => {
                    if (!localStorage.getItem('splashed')) {
                        localStorage.setItem('splashed', Date.now())
                        next({ path: '/nut' })
                        return
                    }

                    next({ path: '/wap' })
                }
            },
        ]
    }
    const router = createRouter({
        history: createWebHistory(process.env.BASE_URL),
        routes: setupRoutes(app.config.globalProperties.$keycloak),
        scrollBehavior(to, from, savedPosition) {
            // If the navigation is triggered to the same route (same path)
            if (to.path === from.path) {
                return { x: 0, y: 0 }  // Scroll to the top
            }

            // If there is a savedPosition (back/forward navigation), restore the scroll position
            if (savedPosition) {
                return savedPosition
            }

            // For normal navigation between different routes, don't scroll to the top
            return { top: 0, left: 0 }
        }
    })

    app.config.globalProperties.$router = router
    app.use(router)
}
